export enum MobileMainContentTypes {
	MAP = "map",
	DETAILS = "details",
	FILTERS = "filters"
}

export type MobileViewType = {
	type: MobileMainContentTypes;
	icon: string;
	className: string;
	btnText: string;
}

export const mobileViews: Record<MobileMainContentTypes, MobileViewType> = {
	map: {
		type: MobileMainContentTypes.MAP,
		icon: "esri-icon-feature-layer",
		className: "icon-btn",
		btnText: "Show Map"
	},
	filters: {
		type: MobileMainContentTypes.FILTERS,
		icon: "esri-icon-search",
		className: "bg-orange no-border icon-btn",
		btnText: "Search Properties"
	},
	details: {
		type: MobileMainContentTypes.DETAILS,
		icon: "esri-icon-table",
		className: "icon-btn",
		btnText: "Show Details"
	}
};